import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  getDanhMucGroupCategories: (params) =>
    API_AUTH.get("danhmucnhomsanpham/getDanhMucGroupCategories", params),
  saveNhomSanPham: (params) =>
    API_AUTH.post("danhmucnhomsanpham/saveNhomSanPham", params),
  saveThietLapGiaNhom: (params) =>
    API_AUTH.post("danhmucnhomsanpham/saveThietLapGiaNhom", params),
  saveThietLapGiaTheoKieuGiaCong: (params) =>
    API_AUTH.post("danhmucnhomsanpham/saveThietLapGiaGiaCongTheoNhom", params),
  deleteNhomSanPham: (params) =>
    API_AUTH.post(
      "danhmucnhomsanpham/deleteNhomSanPham?IdNhom=" +
      params.IdNhom +
      "&iBranch=" +
      params.iBranch
    ),
  getGroupCategoryByUser: (params) => API_AUTH.get(`danhmucnhomsanpham/getGroupCategoryByUser?userName=${params.userName}&iBranch=${params.iBranch}`, {}),
};
